import React, { useMemo } from 'react';
import * as S from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import ThemeToggle from '../../ThemeToggle';

interface HeaderProps {
  menuExpanded: boolean;
  toggleMenu: () => void;
  pageTitle?: string;
}

const Header: React.FC<HeaderProps> = ({
  menuExpanded,
  toggleMenu,
  pageTitle,
}) => {
  return (
    <S.HeaderContainer menuExpanded={menuExpanded}>
      <S.HeaderContent>
        <S.MenuToggleButton
          onClick={toggleMenu}
          aria-label={menuExpanded ? 'Recolher menu' : 'Expandir menu'}
          title={menuExpanded ? 'Recolher menu' : 'Expandir menu'}
        >
          <FontAwesomeIcon icon={faBars} size="xs" />
        </S.MenuToggleButton>
        <S.HeaderTitle>{pageTitle}</S.HeaderTitle>
        <S.HeaderActions>
          <ThemeToggle />
        </S.HeaderActions>
      </S.HeaderContent>
    </S.HeaderContainer>
  );
};

export default React.memo(Header);
